import React, { useState } from 'react'
import { graphql, StaticQuery } from 'gatsby'
import Logo from 'components/Logo'
import LinkWrap from 'components/LinkWrap'
import { StaticImage } from 'gatsby-plugin-image'
import { flatListToHierarchical } from 'js/utils.js'

export default function Header({
  navIsActive,
  setNavIsActive,
  toggleNavIsActive,
}) {
  return (
    <StaticQuery
      query={menuQuery}
      render={(data) => {
        const allMenus = data.allWpMenu.nodes
        let menu = {
          left: allMenus.find((menu) => menu.slug === 'main-left')?.menuItems
            .nodes,
          right: allMenus.find((menu) => menu.slug === 'main-right')?.menuItems
            .nodes,
        }
        menu.left = flatListToHierarchical(menu.left)
        menu.right = flatListToHierarchical(menu.right)
        return (
          <header className='banner'>
            <div className='container'>
              <nav className='nav-primary'>
                <ul id='menu-header-navigation-left' className='nav nav--left'>
                  {menu.left.map((m0, i) => (
                    <M0 key={i} m0={m0} setNavIsActive={setNavIsActive} />
                  ))}
                </ul>

                <a className='banner__logo__link' href='/'>
                  <Logo className='banner__logo' />
                </a>

                <ul
                  id='menu-header-navigation-right'
                  className='nav nav--right'
                >
                  {menu.right.map((m0, i) => (
                    <M0 key={i} m0={m0} setNavIsActive={setNavIsActive} />
                  ))}
                </ul>

                <div className='nav-primary__mobile-toggle'>
                  <input
                    className='nav-primary__mobile-toggle__checkbox'
                    type='checkbox'
                    onClick={toggleNavIsActive}
                  />
                  <span className='nav-primary__mobile-toggle-line'></span>
                  <span className='nav-primary__mobile-toggle-line'></span>
                  <span className='nav-primary__mobile-toggle-line'></span>
                </div>

                <nav className='nav-mobile'>
                  <div className='nav-mobile-bg'></div>

                  <ul
                    id='menu-header-navigation-left-1'
                    className='nav-mobile__left'
                  >
                    {menu.left.map((m0, i) => (
                      <M0
                        key={i}
                        m0={m0}
                        isMobile={true}
                        setNavIsActive={setNavIsActive}
                      />
                    ))}
                  </ul>
                  <ul
                    id='menu-header-navigation-right-1'
                    className='nav-mobile__right'
                  >
                    {menu.right.map((m0, i) => (
                      <M0
                        key={i}
                        m0={m0}
                        isMobile={true}
                        setNavIsActive={setNavIsActive}
                      />
                    ))}
                  </ul>

                  <div className='nav-mobile__extras'>
                    <a
                      href='https://www.gpsenterprise.cn/auth/login'
                      target='_blank'
                      className='nav-mobile__extras__login'
                    >
                      登录
                    </a>

                    <LanMenu />
                  </div>
                  <div className='nav-mobile__social'>
                    <a className='nav-mobile__social__link qr-wrap'>
                      <img
                        className='nav-mobile__social__svg'
                        src='/svg/wechat-grey.svg'
                      />
                      <StaticImage
                        src='../images/qr-wechat.jpg'
                        alt=''
                        className='qr'
                      />
                    </a>
                    <a
                      href='https://www.facebook.com/analyticpartners/'
                      target='_blank'
                      className='nav-mobile__social__link'
                    >
                      <svg
                        id='sm-facebook-mobile'
                        className='nav-mobile__social__svg'
                        viewBox='0 0 27 27'
                      >
                        <path
                          d='M27 13.5C27 21 20.9 27 13.5 27 6 27 0 21 0 13.5 0 6.1 6 0 13.5 0 20.9 0 27 6.1 27 13.5zM14.6 8.8c0-.9.2-1.5 1.4-1.5h1.8l.2-3.2s-.9-.2-2.6-.2c-3.3 0-4.7 2-4.7 4.2v3.1H8.4v3.4h2.3V23h3.9v-8.4h3.2l.2-3.3h-3.4V8.8z'
                          fill='#bdbdbd'
                        ></path>
                      </svg>
                    </a>
                    <a
                      href='https://twitter.com/analyticglobal/'
                      target='_blank'
                      className='nav-mobile__social__link'
                    >
                      <svg
                        id='sm-twitter-mobile'
                        className='nav-mobile__social__svg'
                        viewBox='0 0 27 27'
                      >
                        <path
                          d='M27 13.5C27 21 21 27 13.5 27S0 21 0 13.5 6 0 13.5 0 27 6 27 13.5zm-3.4-4.9c-.7.3-1.4.5-2.2.6.8-.5 1.4-1.2 1.6-2.1-.8.4-1.5.8-2.4.9-.7-.7-1.7-1.2-2.8-1.2-2.1 0-3.8 1.7-3.8 3.8 0 .3 0 .6.1.9-3.2-.2-6-1.7-7.9-4-.3.6-.5 1.3-.5 1.9 0 1.3.7 2.5 1.7 3.2-.6 0-1.2-.2-1.7-.5 0 1.9 1.3 3.4 3.1 3.8-.3.1-.7.1-1 .1-.3 0-.5 0-.7-.1.5 1.5 1.9 2.6 3.6 2.6-1.3 1-2.9 1.8-4.8 1.8-.3 0-.6 0-.9-.1 1.7 1.1 3.7 1.7 5.9 1.7 7.1 0 10.9-5.8 10.9-10.9v-.5c.7-.5 1.3-1.2 1.8-1.9z'
                          fill='#bdbdbd'
                        ></path>
                      </svg>
                    </a>
                    <a
                      href='https://www.linkedin.com/company/analytic-partners/'
                      target='_blank'
                      className='nav-mobile__social__link'
                    >
                      <svg
                        id='sm-linkedin-mobile'
                        className='nav-mobile__social__svg'
                        viewBox='0 0 20 20'
                      >
                        <path
                          d='M20 10c0 5.5-4.5 10-10 10S0 15.5 0 10 4.5 0 10 0s10 4.5 10 10zM7.5 5.2c0-.8-.6-1.5-1.7-1.5-1 0-1.7.6-1.7 1.5 0 .8.6 1.5 1.6 1.5 1.2 0 1.8-.7 1.8-1.5zm-.4 2.7H4.6V15h2.5V7.9zm9.1 3.3c0-2.3-1.1-3.8-2.9-3.8-1 0-1.8.6-2.1 1.5l-.1-1.1H8.6c0 .3.1 1.7.1 1.7v5.4h2.5v-3.8c0-1 .5-1.7 1.2-1.7.8 0 1.3.4 1.3 1.7v3.8h2.5v-3.7z'
                          fill='#bdbdbd'
                        ></path>
                      </svg>
                    </a>
                  </div>
                </nav>
              </nav>
            </div>
          </header>
        )
      }}
    />
  )
}

const M0 = ({ m0, isMobile = false, setNavIsActive }) => {
  const [submenuIsOpen, setSubmenuIsOpen] = useState(false)
  const toggleSubmenuIsOpen = () => {
    setSubmenuIsOpen(!submenuIsOpen)
  }
  let mobileMenuSize = 'large'
  if (m0.children.length < 3) mobileMenuSize = 'small'
  const hasChildren = m0.children.length > 0
  const hasChildrenClass = hasChildren ? 'menu-item-has-children' : ''
  const submenuOpenClass = submenuIsOpen
    ? `sub-menu--active-${mobileMenuSize}`
    : ''
  m0.path = m0.path.replace('/wp', '')
  return (
    <li className={`menu-item ${hasChildrenClass}`}>
      <LinkWrap to={m0.path}>
        <span
          onClick={() => {
            toggleSubmenuIsOpen()
            if (!hasChildren) {
              setNavIsActive(false)
            }
          }}
        >
          {m0.title}
        </span>
      </LinkWrap>
      {hasChildren && (
        <ul className={`sub-menu ${submenuOpenClass}`}>
          {m0.children.map((m1, i) => (
            <M1 key={i} m1={m1} setNavIsActive={setNavIsActive} />
          ))}
        </ul>
      )}
    </li>
  )
}
const M1 = ({ m1, setNavIsActive }) => {
  m1.path = m1.path.replace('/wp', '')
  return (
    <li className={`menu-item`}>
      <LinkWrap to={m1.path} state={{ fromM1: true }}>
        <span onClick={() => setNavIsActive(false)}>{m1.title}</span>
      </LinkWrap>
    </li>
  )
}

const LanMenu = () => {
  const [menuIsOpen, setMenuIsOpen] = useState(false)
  const toggleMenu = () => {
    setMenuIsOpen(!menuIsOpen)
  }
  return (
    <span className='nav-mobile__extras__lang' onClick={toggleMenu}>
      <div className='nav-mobile__extras__svg'>
        <svg id='icon-language' viewBox='0 0 16 16'>
          <g fill='none' fillRule='evenodd'>
            <path
              d='M9.526 15.034c.518-.704.947-1.76 1.242-3.034h3.214a7.216 7.216 0 0 1-4.456 3.034zM2.018 12h3.214c.295 1.274.724 2.33 1.242 3.034A7.216 7.216 0 0 1 2.018 12zM6.474.966C5.956 1.67 5.527 2.726 5.232 4H2.018A7.217 7.217 0 0 1 6.474.966zM13.982 4h-3.214c-.295-1.274-.724-2.33-1.242-3.034A7.217 7.217 0 0 1 13.982 4zm-2.79 3.6c-.02-.991-.11-1.936-.26-2.8h3.508a7.15 7.15 0 0 1 .74 2.8h-3.988zm0 .8h3.988a7.137 7.137 0 0 1-.74 2.8h-3.508c.15-.864.24-1.809.26-2.8zm-6.384-.8H.82a7.137 7.137 0 0 1 .74-2.8h3.508c-.151.864-.24 1.809-.26 2.8zm5.312-2.8c.153.828.251 1.767.272 2.8H5.608c.02-1.033.119-1.972.272-2.8h4.24zM8 .8C8.633.8 9.45 1.98 9.949 4H6.05C6.55 1.98 7.367.8 8 .8zM.82 8.4h3.988c.02.991.109 1.936.26 2.8H1.56a7.137 7.137 0 0 1-.74-2.8zm5.06 2.8a17.439 17.439 0 0 1-.272-2.8h4.784a17.46 17.46 0 0 1-.272 2.8H5.88zm2.12 4c-.633 0-1.45-1.18-1.949-3.2h3.898c-.5 2.02-1.316 3.2-1.949 3.2zM8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0z'
              fill='#FFF'
              mask='url(#b)'
            ></path>
          </g>
        </svg>
      </div>
      <span className='nav-mobile__extras__lang__items'>
        <span className='nav-mobile__extras__lang__items__item current-lang'>
          中文
        </span>

        <span
          className={`nav-mobile__extras__lang__slideout ${
            menuIsOpen ? 'open' : ''
          }`}
        >
          <a
            className='nav-mobile__extras__lang__items__item'
            href='https://analyticpartners.com/'
          >
            en
          </a>
          <a
            className='nav-mobile__extras__lang__items__item'
            href='https://analyticpartners.com/de/'
          >
            de
          </a>
          <a
            className='nav-mobile__extras__lang__items__item'
            href='https://analyticpartners.com/fr/'
          >
            fr
          </a>
        </span>
      </span>
    </span>
  )
}

const menuQuery = graphql`
  query {
    allWpMenu {
      nodes {
        id
        databaseId
        name
        slug
        menuItems {
          nodes {
            key: id
            parentId
            title: label
            path
          }
        }
      }
    }
  }
`
